/* Orion Jewellers: interactions */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var low = root.classList.contains('perf-low');
  var O = window.Orion || { routes: { cart: '/cart', cartAdd: '/cart/add' }, moneyFormat: 'R {{amount}}' };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || O.moneyFormat || 'R {{amount}}';
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, dec, th, ds) {
      var s = (n / 100).toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s[1] ? s[0] + ds + s[1] : s[0];
    }
    if (!m) return fmt(cents, 2, ',', '.');
    var map = {
      amount: fmt(cents, 2, ',', '.'),
      amount_no_decimals: fmt(cents, 0, ',', '.'),
      amount_with_comma_separator: fmt(cents, 2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(cents, 0, '.', ','),
      amount_with_space_separator: fmt(cents, 2, ' ', ','),
      amount_no_decimals_with_space_separator: fmt(cents, 0, ' ', ','),
      amount_with_apostrophe_separator: fmt(cents, 2, "'", '.')
    };
    return format.replace(m[0], map[m[1]] || map.amount);
  }

  function toast(msg, link) {
    var t = d.querySelector('.toast');
    if (!t) { t = d.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); d.body.appendChild(t); }
    t.textContent = '';
    var s = d.createElement('span'); s.textContent = msg; t.appendChild(s);
    if (link) { var a = d.createElement('a'); a.href = link.href; a.textContent = link.label; t.appendChild(a); }
    t.classList.add('is-on'); clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  function initHeader() {
    var header = d.querySelector('[data-header]');
    if (!header) return;
    var on = function () { header.classList.toggle('is-scrolled', window.scrollY > 40); };
    on(); window.addEventListener('scroll', on, { passive: true });
    d.addEventListener('click', function (e) {
      header.querySelectorAll('.nav__details[open]').forEach(function (det) { if (!det.contains(e.target)) det.removeAttribute('open'); });
    });
  }

  function initMenu() {
    var btn = d.querySelector('[data-menu-toggle]'), menu = d.getElementById('mobile-menu');
    if (!btn || !menu) return;
    function set(open, silent) {
      menu.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      d.body.classList.toggle('no-scroll', open);
      if (open) { menu.removeAttribute('inert'); var f = menu.querySelector('a,button'); if (f) f.focus(); }
      else { menu.setAttribute('inert', ''); if (!silent) btn.focus(); }
    }
    btn.addEventListener('click', function () { set(btn.getAttribute('aria-expanded') !== 'true'); });
    menu.querySelectorAll('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { set(false); }); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (menu.classList.contains('is-open')) set(false);
        d.querySelectorAll('.nav__details[open]').forEach(function (det) { det.removeAttribute('open'); });
      }
    });
    var mq = window.matchMedia('(min-width: 1100px)');
    if (mq.addEventListener) mq.addEventListener('change', function (e) { if (e.matches && menu.classList.contains('is-open')) set(false, true); });
  }

  function initSearch() {
    var dlg = d.getElementById('search-dialog');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    d.querySelectorAll('[data-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); dlg.showModal(); var i = dlg.querySelector('input[type=search]'); if (i) i.focus(); });
    });
    dlg.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  var io = ('IntersectionObserver' in window && !reduce) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }) : null;
  function initReveal(scope) {
    (scope || d).querySelectorAll('.reveal, .reveal-img, [data-draw], .const-grid').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-visible');
    });
  }

  var pxEls = [], ticking = false;
  function initParallax(scope) {
    if (reduce || low) return;
    (scope || d).querySelectorAll('[data-parallax]').forEach(function (el) { if (pxEls.indexOf(el) < 0) pxEls.push(el); });
  }
  function updateParallax() {
    var vh = window.innerHeight;
    pxEls.forEach(function (el) {
      if (!el.isConnected) return;
      var r = el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > vh + 200) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.translate = '0 ' + (p * (parseFloat(el.dataset.parallax) || 40)).toFixed(1) + 'px';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () { if (pxEls.length && !ticking) { ticking = true; requestAnimationFrame(updateParallax); } }, { passive: true });

  function initScrollNext(scope) {
    (scope || d).querySelectorAll('[data-scroll-next]').forEach(function (b) {
      if (b._sn) return; b._sn = true;
      b.addEventListener('click', function (e) {
        var sec = b.closest('.shopify-section');
        var next = sec && sec.nextElementSibling;
        if (next) { e.preventDefault(); next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }
      });
    });
  }

  function refreshCount() {
    return fetch(O.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      d.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = c.item_count === 0; });
      return c;
    });
  }
  function addToCart(form) {
    return fetch(O.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'This item could not be added.'); return j; }); })
      .then(function (j) { return refreshCount().then(function () { return j; }); });
  }

  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  function showMedia(scope, id) {
    if (!id) return;
    var found = scope.querySelector('[data-media-id="' + id + '"]');
    if (!found) return;
    scope.querySelectorAll('[data-media-id]').forEach(function (m) { m.hidden = m !== found; });
    scope.querySelectorAll('[data-thumb]').forEach(function (t) { t.setAttribute('aria-current', t.dataset.thumb === String(id) ? 'true' : 'false'); });
  }

  function initProduct(el) {
    if (el._init) return; el._init = true;
    var jsonEl = el.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var form = el.querySelector('form[action*="/cart/add"]');
    var idInput = form && form.querySelector('[name="id"]');
    var priceEl = el.querySelector('[data-price]'), cmpEl = el.querySelector('[data-compare]');
    var btn = el.querySelector('[data-add]'), label = btn && btn.querySelector('span');
    var skuEl = el.querySelector('[data-sku]'), wa = el.querySelector('[data-whatsapp]');
    var groups = Array.prototype.slice.call(el.querySelectorAll('[data-option]'));
    function selected() {
      return groups.map(function (g) {
        if (g.tagName === 'SELECT') return g.value;
        var c = g.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function matches(v, opts) { return v.options.every(function (o, i) { return o === opts[i]; }); }
    function update() {
      var opts = selected();
      groups.forEach(function (g, gi) {
        var lv = g.querySelector('[data-value]'); if (lv) lv.textContent = opts[gi] || '';
        g.querySelectorAll('input, option').forEach(function (inp) {
          var test = opts.slice(); test[gi] = inp.value;
          var ok = data.variants.some(function (v) { return v.available && matches(v, test); });
          var target = inp.tagName === 'OPTION' ? inp : inp.closest('.opt__item');
          if (target) target.classList.toggle('is-unavailable', !ok);
        });
      });
      var v = data.variants.filter(function (x) { return matches(x, opts); })[0];
      if (!btn || !idInput) return;
      if (!v) { btn.disabled = true; label.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (cmpEl) cmpEl.textContent = v.compare_at_price > v.price ? formatMoney(v.compare_at_price) : '';
      btn.disabled = !v.available;
      label.textContent = v.available ? btn.dataset.label : 'Sold out';
      if (skuEl) skuEl.textContent = v.sku || '—';
      if (v.featured_media) showMedia(el, v.featured_media.id);
      if (wa) {
        var msg = 'Hello, I would like to enquire about ' + data.title + (data.variants.length > 1 ? ' (' + v.title + ')' : '') + ' — ' + location.origin + data.url + '?variant=' + v.id;
        wa.href = 'https://wa.me/' + wa.dataset.whatsapp + '?text=' + encodeURIComponent(msg);
      }
      if (groups.length) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (err) {} }
    }
    el.addEventListener('change', function (e) { if (e.target.closest('[data-option]')) update(); });
    if (form && btn) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        btn.disabled = true; btn.classList.add('is-loading');
        addToCart(form).then(function () {
          toast('Added to your cart', { href: O.routes.cart, label: 'View cart' });
        }).catch(function (err) { toast(err.message); }).then(function () {
          btn.classList.remove('is-loading'); update();
        });
      });
    }
    el.querySelectorAll('[data-thumb]').forEach(function (t) { t.addEventListener('click', function () { showMedia(el, t.dataset.thumb); }); });
    update();

    var dlg = el.querySelector('[data-zoom-dialog]');
    if (dlg && typeof dlg.showModal === 'function') {
      var img = dlg.querySelector('[data-zoom-img]'), stage = dlg.querySelector('.zoom__stage');
      var origin = function (e) { var r = img.getBoundingClientRect(); img.style.transformOrigin = Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)) + '% ' + Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)) + '%'; };
      el.querySelectorAll('[data-zoom]').forEach(function (b) {
        b.addEventListener('click', function () { img.src = b.dataset.zoom; img.alt = b.dataset.zoomAlt || ''; dlg.classList.remove('is-zoomed'); dlg.showModal(); });
      });
      stage.addEventListener('click', function (e) { if (!dlg.classList.contains('is-zoomed')) origin(e); dlg.classList.toggle('is-zoomed'); });
      stage.addEventListener('pointermove', function (e) { if (dlg.classList.contains('is-zoomed')) origin(e); });
      dlg.querySelector('[data-zoom-close]').addEventListener('click', function () { dlg.close(); });
    }
  }

  function initRecommendations(scope) {
    (scope || d).querySelectorAll('[data-recommendations][data-url]').forEach(function (el) {
      if (el._loaded) return; el._loaded = true;
      fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = d.createElement('div'); tmp.innerHTML = html;
        var inner = tmp.querySelector('[data-recommendations]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initReveal(el); }
      }).catch(function () {});
    });
  }

  function initFacets(scope) {
    (scope || d).querySelectorAll('form[data-facets]').forEach(function (form) {
      if (form._init) return; form._init = true;
      var t;
      var mobile = function () { return window.matchMedia('(max-width: 989px)').matches; };
      form.addEventListener('change', function (e) {
        if (mobile() && e.target.closest('.filters')) return;
        clearTimeout(t);
        t = setTimeout(function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }, e.target.type === 'number' ? 700 : 0);
      });
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
      });
      var panel = form.querySelector('.filters'), scrim = form.querySelector('.filters-scrim');
      function setOpen(open) {
        panel.classList.toggle('is-open', open); if (scrim) scrim.classList.toggle('is-open', open);
        d.body.classList.toggle('no-scroll', open);
        form.querySelectorAll('.toolbar__filter').forEach(function (x) { x.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        if (open) { var f = panel.querySelector('button, summary'); if (f) f.focus(); }
      }
      form.querySelectorAll('[data-filter-toggle]').forEach(function (b) { b.addEventListener('click', function () { setOpen(!panel.classList.contains('is-open')); }); });
      if (scrim) scrim.addEventListener('click', function () { setOpen(false); });
    });
  }

  function initCartPage() {
    var form = d.getElementById('cart-form');
    if (!form) return;
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-cart-qty]')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var u = form.querySelector('[name=update]');
        if (form.requestSubmit) form.requestSubmit(u); else form.submit();
      }, 450);
    });
  }

  function initSteps(scope) {
    (scope || d).querySelectorAll('.bform').forEach(function (f) {
      var steps = Array.prototype.slice.call(f.querySelectorAll('[data-step]'));
      if (!steps.length || f._init) return; f._init = true;
      var i = 0, first = true;
      var dots = Array.prototype.slice.call(f.querySelectorAll('[data-step-dot]'));
      var prog = f.querySelector('[data-progress]');
      var back = f.querySelector('[data-back]'), next = f.querySelector('[data-next]'), submit = f.querySelector('[data-submit]');
      var summaryEl = f.querySelector('[data-summary]');
      f.classList.add('is-enhanced');
      function summary() {
        if (!summaryEl) return;
        var fd = new FormData(f), rows = {}, skip = /^(form_type|utf8|contact\[Enquiry\]|contact\[POPIA consent\])$/;
        fd.forEach(function (val, key) {
          if (skip.test(key) || !String(val).trim()) return;
          var k = key.replace(/^contact\[|\]$/g, '');
          k = k.charAt(0).toUpperCase() + k.slice(1);
          rows[k] = rows[k] ? rows[k] + ', ' + val : val;
        });
        summaryEl.textContent = '';
        var p = d.createElement('p'); p.className = 'field__label'; p.style.marginBottom = '16px'; p.textContent = 'Your consultation so far'; summaryEl.appendChild(p);
        var dl = d.createElement('dl');
        Object.keys(rows).forEach(function (k) {
          var dt = d.createElement('dt'); dt.textContent = k;
          var dd = d.createElement('dd'); dd.textContent = rows[k];
          dl.appendChild(dt); dl.appendChild(dd);
        });
        summaryEl.appendChild(dl);
        summaryEl.hidden = !Object.keys(rows).length;
      }
      function show(n) {
        i = n;
        steps.forEach(function (s, k) { s.hidden = k !== i; });
        dots.forEach(function (dot, k) {
          dot.classList.toggle('is-done', k < i); dot.classList.toggle('is-active', k === i);
          if (k === i) dot.setAttribute('aria-current', 'step'); else dot.removeAttribute('aria-current');
        });
        if (prog) prog.style.transform = 'scaleX(' + ((i + 1) / steps.length) + ')';
        back.hidden = i === 0; next.hidden = i === steps.length - 1; submit.hidden = i !== steps.length - 1;
        if (i === steps.length - 1) summary();
        if (!first) {
          var hh = parseInt(getComputedStyle(root).getPropertyValue('--header-h'), 10) || 76;
          window.scrollTo({ top: f.getBoundingClientRect().top + window.scrollY - hh - 24, behavior: reduce ? 'auto' : 'smooth' });
          var h = steps[i].querySelector('.bstep__title'); if (h) h.focus({ preventScroll: true });
        }
        first = false;
      }
      function valid() {
        var fields = steps[i].querySelectorAll('input, select, textarea');
        for (var k = 0; k < fields.length; k++) { if (!fields[k].checkValidity()) { fields[k].reportValidity(); return false; } }
        return true;
      }
      next.addEventListener('click', function () { if (valid()) show(i + 1); });
      back.addEventListener('click', function () { show(i - 1); });
      f.addEventListener('submit', function (e) {
        for (var k = 0; k < steps.length; k++) {
          var bad = steps[k].querySelector(':invalid');
          if (bad) { e.preventDefault(); show(k); setTimeout(function () { bad.reportValidity(); }, 60); return; }
        }
        submit.classList.add('is-loading');
      });
      var unsure = f.querySelector('[data-size-unsure]'), size = f.querySelector('[data-size-input]');
      if (unsure && size) unsure.addEventListener('change', function () { size.disabled = unsure.checked; if (unsure.checked) size.value = ''; });
      show(0);
    });
  }

  function init(scope) {
    initReveal(scope); initParallax(scope); initScrollNext(scope);
    (scope || d).querySelectorAll('[data-product]').forEach(initProduct);
    initRecommendations(scope); initFacets(scope); initSteps(scope);
    if (pxEls.length) updateParallax();
  }

  function boot() {
    initHeader(); initMenu(); initSearch(); initCartPage(); init();
    var done = d.querySelector('.bform__done');
    if (done) done.focus();
  }
  if (d.readyState !== 'loading') boot(); else d.addEventListener('DOMContentLoaded', boot);
  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.OrionTheme = { formatMoney: formatMoney, toast: toast, refreshCount: refreshCount };
})();
/* Product gallery constellation: travels down the image and draws top to bottom as you scroll */
;(function(){var w=document.querySelector('.gallery__const'),svg=w&&w.querySelector('svg');if(!svg||!svg.getBBox||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;var vb=svg.viewBox.baseVal,y0=vb.y,h=vb.height||1,items=[],host=w.parentNode,queued=false;function cl(v){return v<0?0:v>1?1:v}w.style.willChange='transform';svg.querySelectorAll('.oc__lines path').forEach(function(p){var b=p.getBBox();p.style.transition='stroke-dashoffset .25s linear';items.push({el:p,a:(b.y-y0)/h,b:(b.y+b.height-y0)/h+.02,line:true})});svg.querySelectorAll('.oc__stars circle').forEach(function(c){var b=c.getBBox(),m=(b.y+b.height/2-y0)/h;c.style.transformBox='fill-box';c.style.transformOrigin='center';c.style.transition='opacity .4s ease,transform .4s ease';items.push({el:c,a:m-.05,b:m+.03})});function update(){queued=false;var r=host.getBoundingClientRect(),vh=window.innerHeight,top=r.top+window.scrollY,end=top+r.height-vh*.55,p=end>40?cl(window.scrollY/end):1,s=p*1.08-.04,max=Math.max(0,r.height-w.offsetHeight-44),y=Math.min(max,Math.max(0,110-r.top-w.offsetTop));w.style.transform='translate3d(0,'+y+'px,0)';items.forEach(function(it){var t=cl((s-it.a)/Math.max(.01,it.b-it.a));if(it.line){it.el.style.strokeDashoffset=1-t}else{it.el.style.opacity=.18+.82*t;it.el.style.transform='scale('+(.45+.55*t)+')'}})}function req(){if(!queued){queued=true;requestAnimationFrame(update)}}update();window.addEventListener('scroll',req,{passive:true});window.addEventListener('resize',req)})();
